import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components/macro';

const Root = styled.div`
  height: 100%;
`;

const Error: React.FunctionComponent<any> = ({ route }) => {
  return (
    <Root>
      <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
    </Root>
  );
};

Error.propTypes = {
  route: PropTypes.object
};

export default Error;
